import styled from 'styled-components';

import { colorPrimary, colorSecondary, colorAccent } from 'styles';

const getApexBorder = props => {
  if (props['data-border']) {
    return 'stroke: #fff;';
  }

  return '';
};

const getApexFill = ({ color }) => {
  switch (color) {
    case 'secondary':
      return colorSecondary;
    case 'blue':
      return colorAccent;
    case 'yellow':
      return '#E7A600';
    case 'violet':
      return '#AF1CC9';
    case 'gray':
      return '#ECECEC';
    case 'primary':
    default:
      return colorPrimary;
  }
};

export const Circle = styled.circle`
  ${getApexBorder}
  fill: ${getApexFill};
`;

export const Rect = styled.rect`
  ${getApexBorder}
  fill: ${getApexFill};
`;

export const Polygon = styled.polygon`
  ${getApexBorder}
  fill: ${getApexFill};
`;
